const prefix = 'invites'

export enum InvitesQueryKeys {
  ContentInvites = `${prefix}/ContentInvites`,
}
